// Recipe library for the dedicated Recipes page. Re-exports RECIPES (single
// source of truth lives in learnContent.js) plus meal-tab metadata.
export { RECIPES } from "./learnContent";

export const RECIPE_MEALS = [
  { k: "all", label: "All" },
  { k: "breakfast", label: "Breakfast" },
  { k: "lunch", label: "Lunch" },
  { k: "dinner", label: "Dinner" },
  { k: "snack", label: "Snacks" },
];
